import "rxjs/add/operator/mergeMap";
import { Types, Creators } from "../reducer";

import * as firebase from "firebase";

export default (action$) =>
  action$.ofType(Types.UPDATE_QUEUE_ITEM).mergeMap((action) => {
    const ref = firebase
      .database()
      .ref(`queues/${action.location}/${action.registrationId}`);

    return ref
      .once("value")
      .then((snap) => {
        if (!snap.exists()) {
          return Creators.completeEditQueueItem();
        }

        return firebase
          .database()
          .ref(`queues/${action.location}/${action.registrationId}`)
          .update(action.updateData);
      })
      .then(() => Creators.completeEditQueueItem());

    // firebase
    //   .database()
    //   .ref(`queues/${action.location}/${action.registrationId}`)
    //   .update(action.updateData)
    //   .then(() => Creators.completeEditQueueItem())
    //   // FIXME: handle error case, a common handling?
    //   .catch(() => Creators.completeEditQueueItem());
  });



// WEBPACK FOOTER //
// ./src/staff/epics/updateQueueItem.js